import AgentChatConversationContent from '@/components/AgentChat/AgentChatConversationContent';
import AgentChatActiveConversationList from '@/components/AgentChat/AgentChatActiveConversationList';

// @vue/component
export default {
  name: 'AgentChat',
  components: {
    AgentChatConversationContent,
    AgentChatActiveConversationList,
  },
};
